import { aed } from "@/lib/format";
import {
  buildReportDocument,
  openReportPrint,
  periodMeta,
  resolveReportLetterhead,
  escapeReportHtml,
} from "@/lib/reportPrintShell";

function cell(value) {
  return value != null && value !== "" ? aed(value) : "";
}

async function buildHtml(title, report, metaHtml, tableHtml) {
  const company = await resolveReportLetterhead({ branchId: report?.branch_id, allBranches: report?.all_branches });
  return buildReportDocument({
    title,
    company,
    metaHtml,
    bodyHtml: tableHtml,
  });
}

export async function printDeliveryReport(report, tab, options = {}) {
  if (!report) return false;
  const withBranch = { ...report, branch_id: report.branch_id ?? options.branchId, all_branches: options.allBranches };

  if (tab === "summary") {
    const rows = (withBranch.rows || [])
      .map(
        (r) => `
      <tr>
        <td>${r.person_code || ""}</td>
        <td>${r.person_name}</td>
        <td class="num">${r.bill_count}</td>
        <td class="num">${cell(r.round_off)}</td>
        <td class="num">${cell(r.net_sales)}</td>
        <td class="num">${cell(r.cash_sales)}</td>
        <td class="num">${r.delivered_count}</td>
        <td class="num">${r.settled_count}</td>
        <td class="num">${cell(r.pending_settlement)}</td>
      </tr>`,
      )
      .join("");

    const html = await buildHtml(
      "Delivery Driver Summary",
      withBranch,
      periodMeta(withBranch),
      `<table>
        <thead><tr>
          <th>Code</th><th>Driver</th><th>Bills</th><th>Round off</th><th>Net</th><th>Cash</th>
          <th>Delivered</th><th>Settled</th><th>Pending</th>
        </tr></thead>
        <tbody>${rows}</tbody>
      </table>`,
    );
    return openReportPrint(html);
  }

  const bills = (withBranch.bills || [])
    .map(
      (b) => `
    <tr>
      <td class="mono">${b.bill_number}</td>
      <td>${b.paid_date || ""} ${b.paid_time || ""}</td>
      <td>${escapeReportHtml(b.customer_name)}</td>
      <td class="mono">${escapeReportHtml(b.customer_tax_number || "")}</td>
      <td>${escapeReportHtml(b.delivery_status_label || "—")}</td>
      <td>${b.delivery_settled ? "Yes" : "No"}</td>
      <td>${(b.payment_method || "").toUpperCase()}</td>
      <td class="num">${cell(b.round_off)}</td>
      <td class="num">${cell(b.net_amount)}</td>
    </tr>`,
    )
    .join("");

  const html = await buildHtml(
    `Delivery Detail — ${withBranch.driver?.name || ""}`,
    withBranch,
    `${periodMeta(withBranch)}
     <div><strong>Driver:</strong> ${escapeReportHtml(withBranch.driver?.code || "")} ${escapeReportHtml(withBranch.driver?.name || "")}</div>`,
    `<table>
      <thead><tr>
        <th>Bill</th><th>Paid</th><th>Customer</th><th>TRN</th><th>Status</th><th>Settled</th><th>Pay</th><th>Round off</th><th>Net</th>
      </tr></thead>
      <tbody>${bills}</tbody>
    </table>`,
  );
  return openReportPrint(html);
}
